import React,{Component}  from 'react';
import{List,Button} from 'antd-mobile';
import {connect} from 'dva';
import Config from '../../config';
import Loading from "../../Loading";

class RemoveBind extends Component{
    constructor(props){
        super(props);
        this.state ={
          message:null
            
        }
    }
    submit(){
    
            this.props.dispatch({type:"index/removeBind",payload:{
                AAA201:localStorage.getItem("AAA201"),
                openid :localStorage.getItem("openid"),
                appid :Config.appid
            }}).then(()=>{
                this.setState({
                    message:this.props.message
                });
            });
       
        
        
    }
    render(){
        return(
            <div>
                <h1>
                 解除绑定
                 </h1>
                <List>
                <Loading loading={this.props.loading} />
                </List>
                <h2> {this.state.message}</h2>
                <Button type="primary" loading={this.props.loading} disabled={this.props.loading} onClick={()=>this.submit()} >解除</Button>
            </div>
        );
    }
}

export default connect(state=>{
    return{
        ...state.index,
        loading:state.loading.global
    }
})(RemoveBind);